import Component from "pages/[lang]/offline-player"
export default Component
